module.exports = __webpack_public_path__ + "assets/img/84a7fb86f3c51bf183b6ecc38ce96ee2.svg";